
import getReduxSelector from 'modules/redux/selectors/get'
import { PRODUCTS_KEY, PRODUCTS_PATH } from 'modules/product/redux/constants.js'

/**
 * @param state
 * @returns {Date|null}
 */
const getCurrentDateSelector = state => {
  const path = PRODUCTS_PATH[PRODUCTS_KEY.CURRENT_DATE]
  return getReduxSelector(path)(state)
}

export default getCurrentDateSelector
